"use client";

import { useProductStore } from "@/lib/store/product.store";
import { formatPrice } from "@/lib/utils";

type Props = {
	price: string | number;
	/** Saleor 返回的币种；不传则沿用全局购物车同步的 currencyUnit（可能滞后） */
	currency?: string | null;
	className?: string;
	size?: "xs" | "sm" | "md" | "lg" | "xl";
};
export default function Price(props: Props) {
	const { price, currency: currencyFromApi, className = "", size = "md" } = props;
	const { currencyUnit } = useProductStore();
	const unit = (currencyFromApi || currencyUnit || "USD").toString();
	if (+price <= 0) return null;
	const pce = price?.toString().startsWith(unit)
		? price
		: `${unit} ${formatPrice(price?.toString())}`;
	return <span className={`${className} text-${size} !font-poppins py-2  `}>{pce}</span>;
}
